import React from 'react';
import WinterJumbo from '../components/WinterJumbo';
import FieldOfViewVisualiser from '../components/FieldOfViewVisualiser';
import { Container } from 'reactstrap'; 


const FieldOfView = () => (
  <div>

    <WinterJumbo 
      title="Field of View Visualiser"
    />    

    <Container>

      <p className="text-justify mt-3">Every infrared sensor has a specific <em>Field of View</em>. It is the average temperature of objects within this field of view that the sensor records (assuming the objects don't reflect a lot of infrared radiation).</p>

      <p className="text-justify">Infrared sensors with a very large field of view measure almost every surface in front of them, whereas sensors with a narrow field of view, such as the Wintersense sensor, are more focused on objects directly ahead.</p>

      <p className="text-justify">The tool below assumes the Wintersense sensor is mounted to a post (e.g. lighting column) by the side of the road. It allows you to adjust various parameters to show how the field of view, and consequently the section of road surface being measured, changes.</p>

      <p className="text-justify">A typical installation is shown to begin with. The sensor is mounted 3 metres up a column that is 1 metre back from lane 1. The field of view angle of 10° is typical for the Wintersense sensor. Only the temperature of surfaces within the field of view (the light blue triangle) effect the temperature reading. In this scenario then the sensor measures the center of lane 1. Note that in reality the temperature of surfaces in the middle of the field of view have a greater weighting on the overall temperature than surfaces at the edge.</p>

      <p className="text-justify">Try adjusting the values below to match your potential installation site. For example, try increasing the <em>Sensor Height up Post</em> to 5 metres and decreasing the <em>Mount Angle</em> to 25°. Notice how a greater proportion of lane 1 is now being measured.</p>

      <FieldOfViewVisualiser/>

    </Container> 

    <br/>
  
  </div>
)

export default FieldOfView;



// WEBPACK FOOTER //
// ./src/pages/field-of-view.js